module.exports = __webpack_public_path__ + "static/media/banner5.08ea7e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner5.png
// module id = 1576
// module chunks = 10